<template>
  <b-input-group>
    <v-select :disabled="disabled" :style="inputStyte" v-model="localValue" :options="groupFormularOptions" @input="mySelectEvent" placeholder="Chọn"/>
  </b-input-group>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'GroupFormularSelect',
  props: {
    value: String,
    inputStyte: Object,
    size: String,
    addBtn: {
      type: Boolean,
      default: false
    },
    formulaOptionsOverride: {
      type: Array,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modalId: '',
      localValue: ''
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      if (newVal == null) {
        this.localValue = null
      }
    }
  },
  mounted () {
    this.modalId = Math.floor(Math.random() * 1000000).toString()
    this.localValue = this.value
  },
  computed: {
    ...mapGetters({
      'groupFormularOptions': 'GroupFormular/listOptionsState'
    })
  },
  methods: {
    myChangeEvent (event) {
      if (event.id) { this.$emit('input', event.id) }
    },
    mySelectEvent (event) {
      if (event.id) { this.$emit('input', event.id) }
    }
  }
}
</script>
